export class SaveAlertModalController {
  url: string;

  static $inject = ['$uibModalInstance'];

  constructor(private $uibModalInstance) {}

  saveAndClose($event) {
    this.$uibModalInstance.close({ event: $event });
  }
}
